import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ProductTag } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-product-tags',
  templateUrl: './product-tags.component.html',
  styleUrls: ['./product-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductTagsComponent {
  @Input()
  tags: Array<ProductTag>;
}
